module.exports = __webpack_public_path__ + "static/media/farmers_list_blur.dd5813bf.png";